import { render } from "./PropsTab.vue?vue&type=template&id=3d2e67b6"
import script from "./PropsTab.vue?vue&type=script&lang=js"
export * from "./PropsTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__